import printJS from 'print-js-updated'
import { b64toBlob } from '../components/pdf/PDFLink';
import moment from "moment";
import { constants } from '../types/constants';

export const beautifyName = (given_name: any, surname: any) => {
  return given_name || surname ? `${surname ? surname.charAt(0).toUpperCase() + surname.slice(1).toLowerCase() : ""} ${given_name ? given_name.charAt(0).toUpperCase() + given_name.slice(1).toLowerCase() : ""}` : "-"
}

export const getBienStatut = (statut: any) => {
  return statut === "SIGNE NOTAIRE" ? "Signé notaire" : statut === "UNIQUE" ? "Vente normale" : statut === "ASSOCIATION CLOTUREE" ? "Association clôturée" : statut === "ASSOCIATION OUVERTE" ? "Association ouverte" : statut === "BLOQUE" ? "Bloqué" : statut === "DISPONIBLE" ? "Disponible" : (statut || "")
}

export const getEncStatut = (statut: any, shortForm: boolean = false) => {
  return statut === constants.STATUT_ENC_DEFAULT ? (shortForm ? "Non Récep." : "Non Réceptionné") : statut === constants.STATUT_ENC_A_NE_PAS_VERSER_NR ? (shortForm ? "À ne pas v." : "Non Réceptionné - À ne pas verser") : statut === constants.STATUT_ENC_PTF ? "Réceptionné" : statut === constants.STATUT_ENC_A_NE_PAS_VERSER_R ? (shortForm ? "R + À ne pas v." : "Réceptionné - À ne pas verser") : statut === constants.STATUT_ENC_EI ? "Versé" : statut === constants.STATUT_ENC_ENCAISSE ? "Encaissé" : statut === constants.STATUT_ENC_IMPAYE ? "Impayé" : statut === constants.STATUT_ENC_REPRESENTE ? "Représenté" : statut === constants.STATUT_ENC_RECUPERE ? "Récupéré" : statut === constants.STATUT_ENC_NOTAIRE ? "Récep. Notaire" : (statut || "")
}

export const getEncModeRegl = (e: any, dashIfEmpty: boolean = true) => {
  return e === constants.MODE_REGL_CHEQUE ? "Chèque" : e === constants.MODE_REGL_VERSEMENT ? "Versement" : e === constants.MODE_REGL_VIREMENT ? "Virement" : e === constants.MODE_REGL_COMPENSATION ? "Compensation" : (e || (dashIfEmpty ? "-" : ""))
}

export const formulaTagsExp = [
  {
    id: constants.COMMISSION_VU_ID,
    name: "VN.",
    description: "Ventes normales",
    color: "cornflowerblue"
  },
  {
    id: constants.COMMISSION_VA_ID,
    name: "VA.",
    description: "Associations",
    color: "cornflowerblue"
  },
  {
    id: constants.COMMISSION_VP_ID,
    name: "VP.",
    description: "Parts d'association",
    color: "cornflowerblue"
  },
  {
    id: constants.COMMISSION_CN_ID,
    name: "CN.",
    description: "Signé client",
    color: "darkslateblue"
  },
  {
    id: constants.COMMISSION_SC_ID,
    name: "SC.",
    description: "Signature en cours",
    color: "darkslateblue"
  },
  {
    id: constants.COMMISSION_L_ID,
    name: "Liv.",
    description: "Livraison",
    color: "darkslateblue"
  },
  {
    id: constants.COMMISSION_E_ID,
    name: "Enc. NR",
    description: "Encaissements non récep.",
    color: "#62af42aa"
  },
  {
    id: constants.COMMISSION_ER_ID,
    name: "Enc. R",
    description: "Encaissements réceptionnés",
    color: "#62af42"
  },
  {
    id: constants.COMMISSION_EEI_ID,
    name: "Enc. AV",
    description: "Encaissements à verser",
    color: "#62af42"
  },
  {
    id: constants.COMMISSION_EEncaisse_ID,
    name: "Enc. En",
    description: "Encaissements encaissés",
    color: "#62af42"
  },
  {
    id: constants.COMMISSION_EImpaye_ID,
    name: "Enc. Imp",
    description: "Encaissements impayés",
    color: "tomato"
  },
  {
    id: constants.COMMISSION_ENotaire_ID,
    name: "Enc. Not",
    description: "Encaissements notaire",
    color: "purple"
  },
  {
    id: constants.COMMISSION_EInactif_ID,
    name: "Enc. I",
    description: "Encaissements inactifs (non versés 1 mois)",
    color: "purple"
  },
  {
    id: constants.COMMISSION_EImpayeInactif_ID,
    name: "Enc. II",
    description: "Encaissements impayés inactifs (1 mois)",
    color: "purple"
  },
]

export const getAvailableVarsComm = e => {
  const availableVars: {n: number, o: string, v: string}[] = [];
  if(!!e.vente_u_percent)
    availableVars.push({n: e.vente_u_percent, o: 'p', v: constants.COMMISSION_VU_ID})
  if(!!e.vente_u_each)
    availableVars.push({n: e.vente_u_each, o: 'f', v: constants.COMMISSION_VU_ID})
  if(!!e.vente_a_percent)
    availableVars.push({n: e.vente_a_percent, o: 'p', v: constants.COMMISSION_VA_ID})
  if(!!e.vente_a_each)
    availableVars.push({n: e.vente_a_each, o: 'f', v: constants.COMMISSION_VA_ID})
  if(!!e.part_percent)
    availableVars.push({n: e.part_percent, o: 'p', v: constants.COMMISSION_VP_ID})
  if(!!e.part_each)
    availableVars.push({n: e.part_each, o: 'f', v: constants.COMMISSION_VP_ID})
  if(!!e.livraison_percent)
    availableVars.push({n: e.livraison_percent, o: 'p', v: constants.COMMISSION_L_ID})
  if(!!e.livraison_each)
    availableVars.push({n: e.livraison_each, o: 'f', v: constants.COMMISSION_L_ID})
  if(!!e.signature_client_percent)
    availableVars.push({n: e.signature_client_percent, o: 'p', v: constants.COMMISSION_SC_ID})
  if(!!e.signature_client_each)
    availableVars.push({n: e.signature_client_each, o: 'f', v: constants.COMMISSION_SC_ID})
  if(!!e.chez_notaire_percent)
    availableVars.push({n: e.chez_notaire_percent, o: 'p', v: constants.COMMISSION_CN_ID})
  if(!!e.chez_notaire_each)
    availableVars.push({n: e.chez_notaire_each, o: 'f', v: constants.COMMISSION_CN_ID})
  if(!!e.enc_non_recep_percent)
    availableVars.push({n: e.enc_non_recep_percent, o: 'p', v: constants.COMMISSION_E_ID})
  if(!!e.enc_non_recep_each)
    availableVars.push({n: e.enc_non_recep_each, o: 'f', v: constants.COMMISSION_E_ID})
  if(!!e.enc_recep_percent)
    availableVars.push({n: e.enc_recep_percent, o: 'p', v: constants.COMMISSION_ER_ID})
  if(!!e.enc_recep_each)
    availableVars.push({n: e.enc_recep_each, o: 'f', v: constants.COMMISSION_ER_ID})
  if(!!e.enc_verse_percent)
    availableVars.push({n: e.enc_verse_percent, o: 'p', v: constants.COMMISSION_EEI_ID})
  if(!!e.enc_verse_each)
    availableVars.push({n: e.enc_verse_each, o: 'f', v: constants.COMMISSION_EEI_ID})
  if(!!e.enc_encaisse_percent)
    availableVars.push({n: e.enc_encaisse_percent, o: 'p', v: constants.COMMISSION_EEncaisse_ID})
  if(!!e.enc_encaisse_each)
    availableVars.push({n: e.enc_encaisse_each, o: 'f', v: constants.COMMISSION_EEncaisse_ID})
  if(!!e.enc_impaye_percent)
    availableVars.push({n: e.enc_impaye_percent, o: 'p', v: constants.COMMISSION_EImpaye_ID})
  if(!!e.enc_impaye_each)
    availableVars.push({n: e.enc_impaye_each, o: 'f', v: constants.COMMISSION_EImpaye_ID})
  if(!!e.enc_inactif_percent)
    availableVars.push({n: e.enc_inactif_percent, o: 'p', v: constants.COMMISSION_EInactif_ID})
  if(!!e.enc_inactif_each)
    availableVars.push({n: e.enc_inactif_each, o: 'f', v: constants.COMMISSION_EInactif_ID})
  if(!!e.enc_impaye_inactif_percent)
    availableVars.push({n: e.enc_impaye_inactif_percent, o: 'p', v: constants.COMMISSION_EImpayeInactif_ID})
  if(!!e.enc_impaye_inactif_each)
    availableVars.push({n: e.enc_impaye_inactif_each, o: 'f', v: constants.COMMISSION_EImpayeInactif_ID})
  return availableVars
}

export const getCommissionWarning = (e: any) => {
  return e === 1 ? "Autre" : e === 2 ? "Sans encaiss." : e === 3 ? "Impayé" : e === 4 ? "À ne pas verser" : e === 5 ? "Non récep." : e === 6 ? "Remise non validée" : e === 7 ? "Enc. Promoteur" : ""
}

export const getCommissionType = (type: any) => {
  let filteredType = type
  let isTRA = false
  let isDES = false
  if(type){
    if(type.includes("TRA_")){
      filteredType = type.replace("TRA_", "")
      isTRA = true
    }
    else if(type.includes("DES_")){
      filteredType = type.replace("DES_", "")
      isDES = true
    }
  }
  let res = filteredType === "VU" ? "Vente normale"
    : filteredType === "VA" ? "Association"
    : filteredType === "VAD" ? "Association débloquée"
    : filteredType === "VP" ? "Part d'association"
    : filteredType === "L" ? "Livraison"
    : filteredType === "SC" ? "Signature en cours"
    : filteredType === "CN" ? "Signé client"
    : filteredType === "E" ? "Encaissement non récep."
    : filteredType === "ER" ? "Encaissement réceptionné"
    : filteredType === "EEI" ? "Encaissement à verser"
    : filteredType === "EEncaisse" ? "Encaissement encaissé"
    : filteredType === "EImpaye" ? "Encaissement impayé"
    : filteredType === "ERepresente" ? "Encaissement représenté"
    : filteredType === "ENotaire" ? "Encaissement récep. notaire"
    : filteredType === "ERecupere" ? "Encaissement récupéré"
    : filteredType === "EImpayeRecupere" ? "Encaissement impayé récupéré"
    : filteredType === "EInactif" ? "Encaissement inactif (non versé 1 mois)"
    : filteredType === "EInactifAnnule" ? "Encaissement inactif annulé"
    : filteredType === "EImpayeInactif" ? "Encaissement impayé inactif (1 mois)"
    : filteredType === "EImpayeInactifAnnule" ? "Encaissement impayé inactif annulé"
    : (filteredType || "")
  
  if(isTRA)
    res = `Transfert ${res}`
  else if(isDES)
    res = `Désistement ${res}`
  
  return res
}

export const downloadImg = (base64: string, fileNameStart: string) => {
  const datetimeAsText = new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear() + '_' + new Date().getHours() + '-' + new Date().getMinutes() + '-' + new Date().getSeconds();
  try{
    const downloadLink = document.createElement("a");
    downloadLink.href = base64;
    downloadLink.download = `${fileNameStart}_${datetimeAsText}`;
    downloadLink.click();
  }
  catch(e){
    console.error("error downloading enc image")
  }
}

export const printBase64Image = (base64: string, contentType: string = 'image/jpeg') => {
  const blob = b64toBlob(base64, contentType);
  const urlFromBlob = URL.createObjectURL(blob);
  printJS(urlFromBlob, "image")
}

export const getColorBudget = e => {
  e = Number(e || 0)
  if(e < 80) return "red"
  if(e < 100) return "orange"
  return "green"
}

export const getNationality = country => {
  const countryToNationality = {
    "Afghanistan": "Afghane",
    "Afrique du Sud": "Sud-Africaine",
    "Albanie": "Albanaise",
    "Algérie": "Algérienne",
    "Allemagne": "Allemande",
    "Andorre": "Andorrane",
    "Angola": "Angolaise",
    "Antigua-et-Barbuda": "Antiguaise",
    "Arabie saoudite": "Saoudienne",
    "Argentine": "Argentine",
    "Arménie": "Arménienne",
    "Australie": "Australienne",
    "Autriche": "Autrichienne",
    "Azerbaïdjan": "Azerbaïdjanaise",
    "Bahamas": "Bahaméenne",
    "Bahreïn": "Bahreïnienne",
    "Bangladesh": "Bangladaise",
    "Barbade": "Barbadienne",
    "Belgique": "Belge",
    "Belize": "Belizienne",
    "Bhoutan": "Bhoutanaise",
    "Bolivie": "Bolivienne",
    "Bosnie-Herzégovine": "Bosnienne",
    "Botswana": "Botswanaise",
    "Brunéi Darussalam": "Brunéienne",
    "Brésil": "Brésilienne",
    "Bulgarie": "Bulgare",
    "Burkina Faso": "Burkinabé",
    "Burundi": "Burundaise",
    "Bélarus": "Bélarusse",
    "Bénin": "Béninoise",
    "Cambodge": "Cambodgienne",
    "Cameroun": "Camerounaise",
    "Canada": "Canadienne",
    "Cap-Vert": "Capverdienne",
    "Chili": "Chilienne",
    "Chine": "Chinoise",
    "Chypre": "Chypriote",
    "Colombie": "Colombienne",
    "Comores": "Comorienne",
    "Congo": "Congolaise",
    "Congo, (République démocratique du)": "Congolaise",
    "Corée, (République de)": "Sud-Coréenne",
    "Corée, (République populaire démocratique de)": "Nord-Coréenne",
    "Costa Rica": "Costaricienne",
    "Croatie": "Croate",
    "Cuba": "Cubaine",
    "Côte d'Ivoire": "Ivoirienne",
    "Danemark": "Danoise",
    "Djibouti": "Djiboutienne",
    "Dominique": "Dominiquaise",
    "Egypte": "Égyptienne",
    "El Salvador": "Salvadorienne",
    "Emirats arabes unis": "Émirienne",
    "Equateur": "Équatorienne",
    "Erythrée": "Érythréenne",
    "Espagne": "Espagnole",
    "Estonie": "Estonienne",
    "Etats-Unis": "Américaine",
    "Ethiopie": "Éthiopienne",
    "Fidji": "Fidjienne",
    "Finlande": "Finlandaise",
    "France": "Française",
    "Gabon": "Gabonaise",
    "Gambie": "Gambienne",
    "Ghana": "Ghanéenne",
    "Grenade": "Grenadienne",
    "Grèce": "Grecque",
    "Guatemala": "Guatémaltèque",
    "Guinée": "Guinéenne",
    "Guinée équatoriale": "Équato-Guinéenne",
    "Guinée-Bissau": "Bissau-Guinéenne",
    "Guyana": "Guyanienne",
    "Géorgie": "Géorgienne",
    "Haïti": "Haïtienne",
    "Honduras": "Hondurienne",
    "Hongrie": "Hongroise",
    "Iles Cook": "Cookienne",
    "Iles Marshall": "Marshallaise",
    "Iles Salomon": "Salomonaise",
    "Inde": "Indienne",
    "Indonésie": "Indonésienne",
    "Iran (République islamique d')": "Iranienne",
    "Iraq": "Iraquienne",
    "Irlande": "Irlandaise",
    "Islande": "Islandaise",
    "Israël": "Israélienne",
    "Italie": "Italienne",
    "Jamahiriya arabe libyenne": "Libyenne",
    "Jamaïque": "Jamaïcaine",
    "Japon": "Japonaise",
    "Jordanie": "Jordanienne",
    "Kazakhstan": "Kazakhstanaise",
    "Kenya": "Kenyanne",
    "Kirghizistan": "Kirghize",
    "Kiribati": "Kiribatienne",
    "Koweït": "Koweïtienne",
    "l'ex-République yougoslave de Macédoine": "Macédonienne",
    "Lesotho": "Lésothienne",
    "Lettonie": "Lettone",
    "Liban": "Libanaise",
    "Libéria": "Libérienne",
    "Liechtenstein": "Liechtensteinoise",
    "Lituanie": "Lituanienne",
    "Luxembourg": "Luxembourgeoise",
    "Madagascar": "Malgache",
    "Malaisie": "Malaisienne",
    "Malawi": "Malawienne",
    "Maldives": "Maldivienne",
    "Mali": "Malienne",
    "Malte": "Maltaise",
    "Maroc": "Marocaine",
    "Maurice": "Mauricienne",
    "Mauritanie": "Mauritanienne",
    "Mexique": "Mexicaine",
    "Micronésie, (Etats fédérés de)": "Micronésienne",
    "Moldova, (République de)": "Moldave",
    "Monaco": "Monégasque",
    "Mongolie": "Mongole",
    "Mozambique": "Mozambicaine",
    "Myanmar": "Birmane",
    "Namibie": "Namibienne",
    "Nauru": "Nauruane",
    "Nicaragua": "Nicaraguayenne",
    "Niger": "Nigérienne",
    "Nigéria": "Nigériane",
    "Nioué": "Niouéenne",
    "Norvège": "Norvégienne",
    "Nouvelle-Zélande": "Néo-Zélandaise",
    "Népal": "Népalaise",
    "Oman": "Omanaise",
    "Ouganda": "Ougandaise",
    "Ouzbékistan": "Ouzbèke",
    "Pakistan": "Pakistanaise",
    "Palaos": "Palauane",
    "Panama": "Panaméenne",
    "Papouasie-Nouvelle Guinée": "Papouasienne",
    "Paraguay": "Paraguayenne",
    "Pays-Bas": "Néerlandaise",
    "Philippines": "Philippine",
    "Pologne": "Polonaise",
    "Portugal": "Portugaise",
    "Pérou": "Péruvienne",
    "Qatar": "Qatarienne",
    "Roumanie": "Roumaine",
    "Royaume-Uni": "Britannique",
    "Russie, (Fédération de)": "Russe",
    "Rwanda": "Rwandaise",
    "Rép. démocratique populaire lao": "Laotienne",
    "République centrafricaine": "Centrafricaine",
    "République dominicaine": "Dominicaine",
    "République tchèque": "Tchèque",
    "Saint-Kitts-et-Nevis": "Névicienne",
    "Saint-Marin": "Saint-Marinaise",
    "Saint-Siège": "Vaticane",
    "Saint-Vincent-et-Grenadines": "Vincentaise",
    "Sainte-Lucie": "Saint-Lucienne",
    "Samoa": "Samoane",
    "Sao Tomé-et-Principe": "Santoméenne",
    "Serbie-et-Monténégro": "Serbe",
    "Seychelles": "Seychelloise",
    "Sierra Leone": "Sierraléonaise",
    "Singapour": "Singapourienne",
    "Slovaquie": "Slovaque",
    "Slovénie": "Slovène",
    "Somalie": "Somalienne",
    "Soudan": "Soudanaise",
    "Sri Lanka": "Sri-Lankaise",
    "Suisse": "Suisse",
    "Suriname": "Surinamaise",
    "Suède": "Suédoise",
    "Swaziland": "Swazie",
    "Syrie, (République arabe de)": "Syrienne",
    "Sénégal": "Sénégalaise",
    "Tadjikistan": "Tadjike",
    "Tanzanie, (République-Unie de)": "Tanzanienne",
    "Tchad": "Tchadienne",
    "Territoire palestinien occupé": "Palestinienne",
    "Thaïlande": "Thaïlandaise",
    "Timor-Leste": "Est-Timoraise",
    "Togo": "Togolaise",
    "Tonga": "Tongienne",
    "Trinité-et-Tobago": "Trinidadienne",
    "Tunisie": "Tunisienne",
    "Turkménistan": "Turkmène",
    "Turquie": "Turque",
    "Tuvalu": "Tuvaluane",
    "Ukraine": "Ukrainienne",
    "Uruguay": "Uruguayenne",
    "Vanuatu": "Vanuatuane",
    "Venezuela": "Vénézuélienne",
    "Viet Nam": "Vietnamienne",
    "Yémen": "Yéménite",
    "Zambie": "Zambienne",
    "Zimbabwe": "Zimbabwéenne"
  };
  
  return countryToNationality[country] || "Marocaine"
};

export const verifyEncDate = (ve, ventePrice, venteDate, minEnc, minEncIsNumber, ignoreNonEncaisse, forceBlockSaisie) => {
  ve = ve?.filter(e => e.encaissement?.notValid != 1)
  let block = false
  let blockMsg
  if(ignoreNonEncaisse)
    return {block, blockMsg}
  if(forceBlockSaisie){
    block = true
    blockMsg = `Vente bloquée à la saisie (Forcée)`
    return {block, blockMsg}
  }
  if(ve?.find(e => e.encaissement?.STATUT === constants.STATUT_ENC_IMPAYE)){
    block = true
    blockMsg = `Vente bloquée, un chèque impayé a été détecté`
    return {block, blockMsg}
  }
  const sumEncaisse = ve?.filter(e => e.encaissement?.MODE_REGL === constants.MODE_REGL_VERSEMENT || e.encaissement?.STATUT === constants.STATUT_ENC_ENCAISSE || e.encaissement?.STATUT === constants.STATUT_ENC_REPRESENTE).reduce((e, t) => e + Number(t.PART || 0), 0)
  minEnc = Number(minEnc || 0)
  let minAllowed
  if(minEnc){
    if(minEncIsNumber == 1)
      minAllowed = minEnc
    else
      minAllowed = ventePrice * (Number(minEnc || 0) / 100)
  }
  
  const isOlderThan4Months = moment(venteDate).isBefore(moment().subtract(4, 'months'))
  const isOlderThan1Month = moment(venteDate).isBefore(moment().subtract(1, 'months'))
  const isOldVente = moment(venteDate).isBefore(moment("2025-03-17"))
  if(isOlderThan4Months){
    if(sumEncaisse <= 0){
      block = true
      blockMsg = `Vente bloquée, aucun chèque n'a été encaissé après 4 mois de la vente`
    }
    else if(!isOldVente && sumEncaisse < minAllowed){
      block = true
      blockMsg = `Vente bloquée, il faut au moins encaisser ${Number(minAllowed || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH après 4 mois de la vente`
    }
  }
  else if(isOlderThan1Month && !isOldVente){
    if(sumEncaisse < minAllowed * .5){
      block = true
      blockMsg = `Vente bloquée, il faut au moins encaisser ${(Number(minAllowed || 0) * .5).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH après 1 mois de la vente`
    }
  }
  return {block, blockMsg}
}
